module.exports = __webpack_public_path__ + "img/7.139a46ad.svg";